import { Box, Skeleton, SkeletonText } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

const DashboardServicesEmptySkeleton = () => {
    const { darkMode } = useSelector((state) => state.settings);
    const skeletonStartColor = darkMode ? 'whiteAlpha.200' : 'gray.100';
    const skeletonEndColor = darkMode ? 'whiteAlpha.300' : 'gray.300';

    return (
        <Box padding="20px 0px">
            <Skeleton
                height="61px"
                width="100%"
                maxWidth="1064px"
                borderRadius="md"
                mb={4}
                startColor={skeletonStartColor}
                endColor={skeletonEndColor}
            />
            <SkeletonText
                noOfLines={2}
                spacing={3}
                skeletonHeight={4}
                startColor={skeletonStartColor}
                endColor={skeletonEndColor}
            />
        </Box>
    );
};

export default DashboardServicesEmptySkeleton;
